import React, { useState, useEffect } from "react";
import { Modal, Input } from "@iq/models";
import { requestJson, assertOk } from "../../services/storeApi";

function RenameProduct({ isOpen, onClose, productId, currentName = "", onRenameSuccess }) {
    const [newProductName, setNewProductName] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isOpen) {
            setNewProductName(currentName);
            setErrorMessage("");
        }
    }, [isOpen, currentName]);

    async function handleRename() {
        const trimmedName = newProductName.trim();
        if (!trimmedName) {
            setErrorMessage("Product name cannot be empty.");
            return;
        }

        if (!productId) {
            setErrorMessage("No product selected for rename.");
            return;
        }

        setIsSaving(true);
        setErrorMessage("");

        try {
            const { response, payload } = await requestJson(`/products/${productId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ product_name: trimmedName }),
            });

            assertOk(response, payload, "Failed to rename product");
            onRenameSuccess?.();
            onClose();
        } catch (error) {
            setErrorMessage(error?.message || "Failed to rename product");
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Rename Product">
            <Input
                label="New Product Name"
                value={newProductName}
                onChange={(e) => setNewProductName(e.target.value)}
                error={errorMessage}
            />
            <button
                type="button"
                className="btn"
                onClick={handleRename}
                disabled={isSaving}
                style={{
                    width: "100%",
                    justifyContent: "center",
                    marginTop: "0.75rem",
                    backgroundColor: "var(--action-accent)",
                    color: "var(--fg-on-action-accent)",
                    borderRadius: "var(--radius-md)",
                    padding: "0.75rem 1rem",
                    fontSize: "1rem",
                }}
            >
                {isSaving ? "Saving..." : "Rename"}
            </button>
        </Modal>
    );
}

export default RenameProduct;